/**
 * @see https://github.com/dcastil/tailwind-merge/blob/f1d7ac635dc6deb05a60dba84204fe2d0730d805/src/lib/tw-join.ts
 */

export type ClassNameValue = ClassNameArray | string;
type ClassNameArray = ClassNameValue[];

export function cx(...classLists: ClassNameValue[]): string {
    let index = 0;
    let argument: ClassNameValue | undefined;
    let resolvedValue: string;
    let string = '';

    while (index < classLists.length) {
        if ((argument = classLists[index++])) {
            if ((resolvedValue = toValue(argument ?? ''))) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
}

function toValue(mix: ClassNameArray | string) {
    if (typeof mix === 'string') {
        return mix;
    }

    let resolvedValue: string;
    let string = '';

    for (let k = 0; k < mix.length; k++) {
        if (mix[k]) {
            if ((resolvedValue = toValue(mix[k] as ClassNameArray | string))) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }

    return string;
}
